export const buildInfo = { version: '1.0.0', buildNumber: 20260904 };
